import React, { memo, FC, useMemo } from 'react';
import {
  makeStyles,
} from '@fluentui/react-components';
import classNames from 'classnames';
import { OverviewCardFooter, usePaginationConfig } from '@bingads-webui-campaign-react/overview-card-footer';

import { LoadShimmer } from './load-shimmer';
import { Tip } from './tip';
import { useActionButtons } from './use-action-buttons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

interface IOverviewWelcomeTipsProps {
  isLoading?: boolean;
  pages: string[];
  hasPaymentPermission: boolean;
  showWelcomeMsg: boolean;
  isPaymentFirstTile: boolean;
  hasCoupon: boolean
  name: string;
  serverContext: any;
  getLocalizedSupportLink: Function;
  i18n: any;
}

export const OverviewWelcomeTips: FC<IOverviewWelcomeTipsProps> = memo((props: IOverviewWelcomeTipsProps) => {
  const {
    isLoading,
    pages,
    hasPaymentPermission,
    showWelcomeMsg,
    isPaymentFirstTile,
    hasCoupon,
    name,
    serverContext,
    getLocalizedSupportLink,
    i18n,
  } = props;
  const classes = useStyles();

  const {
    state,
    renderPagination,
  } = usePaginationConfig<string>({
    data: pages,
    pageSize: 1,
    i18n,
  });

  const actionButtons = useActionButtons({
    i18n, getLocalizedSupportLink, serverContext, hasPaymentPermission, isPaymentFirstTile, hasCoupon, showWelcomeMsg,
  });
  const footerButtonConfigs = useMemo(() => (actionButtons[pages[state.current - 1]]), [actionButtons, pages, state]);

  if (isLoading || state.current < 1) {
    return <LoadShimmer />;
  }

  return (
    <div className={classNames('overview-welcome-tips', classes.container)}>
      <Tip tipId={pages[state.current - 1]} showWelcomeMsg={showWelcomeMsg} isPaymentFirstTile={isPaymentFirstTile} hasCoupon={hasCoupon} name={name} i18n={i18n} />
      <OverviewCardFooter footerButtonConfigs={footerButtonConfigs} renderPagination={renderPagination} />
    </div>
  );
});

OverviewWelcomeTips.defaultProps = {
  isLoading: false,
};
